<template>
  <div>
    <div v-if="!isH5">
      <div class="i-b-box">
        <el-carousel :height="bannerHeight+'px'">
          <el-carousel-item
            v-for="item in bannerList"
            :key="item"
          >
            <img
              ref="bannerImgHeight"
              class="i-b-img"
              :src="item"
              alt=""
            >
          </el-carousel-item>
        </el-carousel>
        <div class="i-b-b">
          <div class="i-b-b-l">全国服务热线</div>
          <div class="i-b-b-r">
            <img
              class="r-img"
              src="@/image/index/jp_phone.png"
            >
            <div>0755-369915</div>
          </div>
        </div>
        <div style="position:absolute;left:0;top:0;width:100%;z-index:8;">
          <headtop />
        </div>
      </div>

      <div class="i-pd">
        <img
          class="i-pd-bgc"
          src="@/image/index/jp_bgc2.png"
        >
        <div class="i-pz-tb">
          <div class="i-title-df">
            <img
              class="i-pd-img"
              src="@/image/index/jp_icon01.png"
            >
            <div
              class="i-text-df"
              style="color:#3E3F3F;"
            >PRODUCT DISPLAY</div>
            <div class="i-title-b">
              <div class="i-t-yd"></div>
              <div class="i-t-text">产品品质</div>
              <div class="i-t-yd"></div>
            </div>
          </div>
          <div class="i-pz-con">
            <img
              class="i-pz-img"
              src="@/image/index/jp_pz_icon01.png"
            >
            <div class="i-pz-con-box">
              <div
                class="i-pz-con-tr"
                v-for="(item,index) in infoList"
                :key="index"
              >
                <img
                  class="i-pz-con-df pz-A"
                  :class="index==1?'pz-B':(index==2?'pz-C':'')"
                  :src="item.img"
                >
                <div class="i-pz-con-text-df">
                  <div class="fwb c_212121 i-pz-t">{{item.name}}</div>
                  <div class="margin-top-xs c_3e3e3e fs24 i-pz-con-maxwidth">{{item.val}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="i-pd">
        <img
          class="i-pd-bgc"
          src="@/image/index/jp_bgc.png"
        >
        <div class="i-pd-tb">
          <div class="i-title-df">
            <img
              class="i-pd-img"
              src="@/image/index/jp_icon01.png"
            >
            <div class="i-text-df">PRODUCT DISPLAY</div>
            <div class="i-title-b">
              <div class="i-t-yd"></div>
              <div class="i-t-text">产品展示</div>
              <div class="i-t-yd"></div>
            </div>
          </div>
          <div class="i-pd-sp">
            <div class="i-pd-swiper-ul flex">
              <img
                class="i-pd-swiper-li"
                src="@/image/index/1_03.png"
                alt=""
              >
              <img
                class="i-pd-swiper-li"
                src="@/image/index/1_05.png"
                alt=""
              >
              <img
                class="i-pd-swiper-li"
                src="@/image/index/1_07.png"
                alt=""
              >
            </div>
            <div
              class="i-pd-sp-btn"
              @click="goNav('product')"
            >浏览更多</div>
          </div>
        </div>
      </div>

      <div class="i-bottom flex">
        <div
          class="b-df-s b-bgc"
          @click="goNav('about')"
        >
          <div class="b-df-s-center">
            关于家品
          </div>
          <div
            class="b-df-mark flex flex-direction_column justify-content_flex-center align-items_center"
            style=""
          >
            <div class="c_white fs24">关于家品</div>
            <div class="c_white fs14 mt14">About lekoujia</div>
            <div class="c_white fs18 b-mark-btn">了解更多</div>
          </div>
        </div>
        <div
          class="b-df-s b-bgc2"
          @click="goNav('contact')"
        >
          <div class="b-df-s-center">
            联系家品
          </div>
          <div
            class="b-df-mark flex flex-direction_column justify-content_flex-center align-items_center"
            style=""
          >
            <div class="c_white fs24">联系家品</div>
            <div class="c_white fs14 mt14">Contact lekoujia</div>
            <div class="c_white fs18 b-mark-btn">了解更多</div>
          </div>
        </div>
      </div>

      <footb />
    </div>
    <div v-else-if="isH5">
      <headtop :isH5="isH5" />
      <img
        class="m-banner"
        src="@/image/mobile/banner.png"
        alt=""
      >
      <div class="m-one-box">
        <div class="m-one-left">全国服务热线</div>
        <div class="m-one-right flex">
          <img
            src="@/image/mobile/icon_white_call.png"
            alt=""
          >
          <div>0755-369915</div>
        </div>
      </div>
      <div class="m-two-pro">
        <div>PRODUCT DISPLAY</div>
        <div class="m-two-pro-title">产品展示</div>
        <img
          src="@/image/mobile/icon_01.png"
          alt=""
          class="m-df-img"
        >
        <img
          src="@/image/mobile/icon_02.png"
          alt=""
          class="m-df-img mt4"
        >
        <img
          src="@/image/mobile/icon_03.png"
          alt=""
          class="m-df-img mt4"
        >
        <div
          class="m-two-btn"
          @click="goNav('product')"
        >
          浏览更多
        </div>
      </div>
      <div class="m-three-wrap flex box-tb box-align-center">
        <div>PRODUCT DISPLAY</div>
        <div class="m-two-pro-title">产品品质</div>
        <div
          class="m-three-li flex"
          :style="index==0?'margin-top:0;':''"
          v-for="(item,index) in infoList"
          :key="index"
        >
          <img
            class="m-three-left-img"
            :src="item.img"
          >
          <div class="m-thrss-right">
            <div>{{item.title}}</div>
            <p class="overflow_2">{{item.val}}</p>
          </div>
        </div>
      </div>
      <div
        class="m-four-wrap"
        @click="goNav('about')"
      >
        <!-- <img
          src="@/image/mobile/bgc_02.png"
          alt=""
        > -->
        <img
          src="@/image/index/n_1.jpg"
          alt=""
        >

        <div class="m-four-marks flex box-pack-center box-align-center">
          关于家品
        </div>
      </div>
      <div
        class="m-four-wrap"
        @click="goNav('contact')"
      >
        <img
          src="@/image/mobile/bgc_03.png"
          alt=""
        >
        <div class="m-four-marks flex box-pack-center box-align-center">
          联系家品
        </div>
      </div>
      <footb :isH5="isH5" />
    </div>
  </div>
</template>

<script>
import headtop from "@/components/headtop/headtop.vue";
import footb from "@/components/footb/index.vue";
import zmA from "@/image/index/jp_pz_A.png"
import zmB from "@/image/index/jp_pz_B.png"
import zmC from "@/image/index/jp_pz_C.png"
import banner1 from "@/image/index/jp_banner.png"
import banner2 from "@/image/about/banner_01.png"
import banner3 from "@/image/products/banner_01.png"

export default {
  data () {
    return {
      infoList: [{ img: zmA, title: '精选原料', val: '精选优质黄豆结合优良菌种，长达数月阳光酿晒充分发酵。精选优质黄豆结合优精选优' }, { img: zmB, title: '精选原料', val: '精选优质黄豆结合优良菌种，长达数月阳光酿晒充分发酵。精选优质黄豆结合优精选优' }, { img: zmC, title: '精选原料', val: '精选优质黄豆结合优良菌种，长达数月阳光酿晒充分发酵。精选优质黄豆结合优精选优精选优质黄豆结合优良菌种，长达数月阳光酿晒充分发酵。精选优质黄豆结合优精选优' }],
      bannerList: [banner1, banner2, banner3],
      bannerHeight: ''
    };
  },
  components: {
    headtop,
    footb
  },
  computed: {
    isH5 () {
      return this.$store.state.WindowWidth < 950
    }
  },
  mounted () {
    this.bannerHeight = (this.$store.state.WindowWidth / 1920) * 750;
  },
  methods: {
    goNav (name) {
      if (!name) return;
      this.$router.push({ name });
    }
  }
};

</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue